import React, { useEffect, useState } from "react";
import Input from "../../../../../components/FormComponents/Input";
import Textarea from "../../../../../components/FormComponents/Textarea";
import { extractVariables } from "../../../../../commonFunctions/fileFolderConfig";
import SingleSelectBox from "../../../../../components/FormComponents/SingleSelectBox";
import ChipList from "../../../../../components/BuilderComponents/ChipList";
import { mapArrayToObject } from "../../../../../commonFunctions/arrayFunc";
import ButtonActionIcon from "../../../../../components/BuilderComponents/ButtonActionIcon";
import { RdbmsFormVariableMapping } from "../../../RDBMSForm/RdbmsFormQuery";

const EditLookupRdbms = (props) => {
  const { editFieldData, setEditFieldData, fields } = props;
  const [variable, setVariable] = React.useState([]);

  const handleChangeInput = (name, value) => {
    setEditFieldData({ ...editFieldData, [name]: value });
  };

  const handleChangePrefillQuery = (e) => {
    const value = e.target.value;
    const data = extractVariables(value);
    setVariable(data);
    setEditFieldData({ ...editFieldData, lookup_query: value });
  };

  const addDataVarmap = (data) => {
    setEditFieldData({ ...editFieldData, data_varmap: data });
  };

  const addFilterMap = (data) => {
    setEditFieldData({ ...editFieldData, filter_varmap: [...editFieldData.filter_varmap, data] });
  };

  const handleChangeFilterMap = (data) => {
    setEditFieldData({ ...editFieldData, filter_varmap: data });
  };

  const handleChangePrimaryKey = (data) => {
    setEditFieldData({ ...editFieldData, primary_key: data });
  };

  useEffect(() => {
    const data = extractVariables(editFieldData.lookup_query);
    setVariable(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="builder_form">
      <Input
        label="Label"
        value={editFieldData.label}
        name="label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <Input
        label="Form Display Label"
        value={editFieldData.form_display_label}
        name="form_display_label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <Textarea value={editFieldData.lookup_query} label="Lookup Query" onChange={handleChangePrefillQuery} />
      <SingleSelectBox
        options={variable}
        selectedData={editFieldData.primary_key}
        onChange={(data) => handleChangePrimaryKey(data)}
        label="Primary Key"
        containerClassName="m_0"
      />
      <h4 className="mt_4">Display Fields</h4>
      <AddLookupRdbmsDataVarmap variable={variable} onAdd={addDataVarmap} initialData={editFieldData?.data_varmap} />
      {/* <RdbmsFormVariableMapping
        map={editFieldData.data_varmap || []}
        onChange={handleChangeDataVarmap}
        fields={mapArrayToObject(fields || []).result}
      /> */}
      <h4 className="mt_4">Filter Map</h4>
      <AddLookupRdbmsFilterMap fields={fields} variable={variable} onAdd={addFilterMap} />
      <RdbmsFormVariableMapping
        map={editFieldData.filter_varmap || []}
        onChange={handleChangeFilterMap}
        fields={mapArrayToObject(fields || []).result}
      />
    </div>
  );
};

const AddLookupRdbmsDataVarmap = ({ variable, onAdd, initialData }) => {
  const [selectedVariables, setSelectedVariables] = useState(initialData);

  const handleSelectVariable = (data) => {
    if (data && !selectedVariables.includes(data)) {
      const updatedVariables = [...selectedVariables, data];
      setSelectedVariables(updatedVariables);
      onAdd(updatedVariables);
    }
  };

  const handleRemoveVariable = (chip, index) => {
    const updatedVariables = selectedVariables.filter((_, i) => i !== index);
    setSelectedVariables(updatedVariables);
    onAdd(updatedVariables);
  };

  return (
    <div className="d_flex flex_column gap_2">
      <SingleSelectBox
        options={variable}
        selectedData={variable}
        onChange={handleSelectVariable}
        label="Variable"
        containerClassName="m_0"
      />
      <div className="d_flex">
        {selectedVariables.length > 0 && (
          <ChipList chips={selectedVariables} removeChip={handleRemoveVariable} containerClassName="mt_2" />
        )}
      </div>
    </div>
  );
};

const AddLookupRdbmsFilterMap = ({ fields, variable, onAdd }) => {
  const initialMapState = {
    source: "",
    target: "",
    type: "form"
  };
  const [mapData, setMapData] = useState(initialMapState);
  const handleChangeTarget = (data) => {
    setMapData({ ...mapData, target: data });
  };
  const handleChangeSource = (data) => {
    setMapData({ ...mapData, source: data });
  };
  const handleChangeType = (data) => {
    setMapData({ ...mapData, type: data });
  };
  const addMapToFilterMap = () => {
    onAdd(mapData);
    setMapData(initialMapState);
  };
  const typeOptions = ["token", "form", "input"];
  return (
    <div className="d_flex gap_2 align_end">
      <SingleSelectBox
        options={variable}
        selectedData={mapData.target}
        onChange={handleChangeTarget}
        label="Variable"
        containerClassName="m_0"
      />
      <SingleSelectBox
        options={typeOptions}
        selectedData={mapData.type}
        onChange={handleChangeType}
        label="type"
        containerClassName="m_0"
      />
      {mapData.type === "form" && (
        <SingleSelectBox
          options={fields}
          labelKey={["label"]}
          selectedData={mapData.source}
          onChange={(data) => handleChangeSource(data.id)}
          label="Field"
          containerClassName="m_0"
        />
      )}
      {mapData.type === "token" && (
        <Input value={mapData.source} label="Enter" onChange={(e) => handleChangeSource(e.target.value)} />
      )}
      {mapData.type === "input" && <Input placeholder="search query" label="search" disabled />}
      <ButtonActionIcon type="add" onClick={addMapToFilterMap} />
    </div>
  );
};

export default EditLookupRdbms;
